import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Wifi, WifiOff, RefreshCw, AlertTriangle } from "lucide-react";
import { getQueue, subscribe, flush } from "@/lib/offline";

export default function OfflineBar() {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState(getQueue().length);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    const on = () => setOnline(true), off = () => setOnline(false);
    window.addEventListener("online", on); window.addEventListener("offline", off);
    const un = subscribe(() => setPending(getQueue().length));
    return () => { window.removeEventListener("online", on); window.removeEventListener("offline", off); un(); };
  }, []);
  const sync = async () => { setBusy(true); await flush(true); setBusy(false); setPending(getQueue().length); };
  return (
    <div className={`mb-3 rounded-xl border px-3 py-2 flex items-center justify-between gap-2 text-sm ${online ? "bg-white" : "bg-orange-50 border-orange-300"}`} data-testid="offline-bar">
      <span className="flex items-center gap-2" data-testid="offline-status">
        {online ? <Wifi className="h-4 w-4 text-brand-600" /> : <WifiOff className="h-4 w-4 text-orange-600" />}
        <b>{online ? "En ligne" : "Hors ligne"}</b>
        {pending > 0 && <span className="rounded-full bg-orange-600 text-white text-[11px] px-2 py-0.5" data-testid="offline-pending">{pending} en attente</span>}
      </span>
      <span className="flex items-center gap-1">
        <Link to="/vi/conflits" className="text-xs text-slate-500 hover:text-brand-700 flex items-center" data-testid="offline-conflicts-link"><AlertTriangle className="h-3.5 w-3.5 mr-1" />Conflits</Link>
        {pending > 0 && <Button size="sm" variant="outline" onClick={sync} disabled={busy} data-testid="offline-sync-now"><RefreshCw className={`h-3.5 w-3.5 mr-1 ${busy ? "animate-spin" : ""}`} />Synchroniser</Button>}
      </span>
    </div>
  );
}
